"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../utils/constants");
var muiKeyFill16 = {
    paths: [
        {
            path: 'M10,0.295354516 L15.704633,5.99974554 C16.0984557,6.39355156 16.0984557,7.03203727 15.704633,7.42584329 L11.4261582,11.7041366 C11.0323355,12.0979426 10.3938227,12.0979426 10,11.7041366 L9.148,10.852 L4,16 L-1.13686838e-13,16 L-1.13686838e-13,12 L5.148,6.852 L4.29536704,5.99974554 C3.90154432,5.60593952 3.90154432,4.9674538 4.29536704,4.57364778 L8.57384176,0.295354516 C8.96766448,-0.0984515053 9.60617728,-0.0984515053 10,0.295354516 Z M6.82842712,8.32842712 L2,12.8284271 L2,14 L3.17157288,14 L8,9.5 L6.82842712,8.32842712 Z M9.28692088,3.86059891 C8.89309816,4.25440493 8.89309816,4.89289064 9.28692088,5.28669666 L10.7130791,6.71279442 C11.1069018,7.10660044 11.7454146,7.10660044 12.1392374,6.71279442 C12.5330601,6.3189884 12.5330601,5.68050268 12.1392374,5.28669666 L10.7130791,3.86059891 C10.3192564,3.46679288 9.6807436,3.46679288 9.28692088,3.86059891 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Key',
    width: 16,
    height: 16,
};
var muiKeyFill24 = {
    paths: [
        {
            path: 'M9.26315789,10.8456463 L7.05263158,13.0561726 L7.05263158,14.7403832 L2,19.7930147 L2,22.0172192 L4.22420445,22.0172192 L9.27683603,16.9645876 L10.9610466,16.9645876 L13.1715729,14.7540613 L9.26315789,10.8456463 Z M14.4345777,16.3194836 L11.7894737,18.9645876 L10.1052632,18.9645876 L5.05263158,24.0172192 L0,24.0172192 L0,18.9645876 L5.05263158,13.911956 L5.05263158,12.2277455 L7.69773559,9.5826415 L6.3266035,8.21150941 C5.89113217,7.77603808 5.89113217,7.06999956 6.3266035,6.63452823 L12.6345282,0.326603497 C13.0699996,-0.108867832 13.7760381,-0.108867832 14.2115094,0.326603497 L23.6733965,9.78849059 C24.1088678,10.2239619 24.1088678,10.9300004 23.6733965,11.3654718 L17.3654718,17.6733965 C16.9300004,18.1088678 16.2239619,18.1088678 15.7884906,17.6733965 L14.4345777,16.3194836 Z M16.2487286,4.93145388 C15.8582043,4.54092959 15.2250393,4.54092959 14.834515,4.93145388 C14.4439907,5.32197817 14.4439907,5.95514315 14.834515,6.34566744 L17.6629422,9.17409457 C18.0534664,9.56461886 18.6866314,9.56461886 19.0771557,9.17409457 C19.46768,8.78357028 19.46768,8.1504053 19.0771557,7.75988101 L16.2487286,4.93145388 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Key',
    width: 24,
    height: 25,
};
var muiKeyFill = {
    base: muiKeyFill16,
    smIcon: muiKeyFill16,
    lgIcon: muiKeyFill24,
};
exports.muiKeyFill = muiKeyFill;
//# sourceMappingURL=keyFill.js.map